import createIcon from '../../createIcon';

/**
 * @component @name Money
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSA4SDdWMTZINVY4Wk0xMiA4SDlDOC40NSA4IDggOC40NSA4IDlWMTVDOCAxNS41NSA4LjQ1IDE2IDkgMTZIMTJDMTIuNTUgMTYgMTMgMTUuNTUgMTMgMTVWOUMxMyA4LjQ1IDEyLjU1IDggMTIgOFpNMTEgMTRIMTBWMTBIMTFWMTRaTTE4IDhIMTVDMTQuNDUgOCAxNCA4LjQ1IDE0IDlWMTVDMTQgMTUuNTUgMTQuNDUgMTYgMTUgMTZIMThDMTguNTUgMTYgMTkgMTUuNTUgMTkgMTVWOUMxOSA4LjQ1IDE4LjU1IDggMTggOFpNMTcgMTRIMTZWMTBIMTdWMTRaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMiA0VjIwSDIyVjRIMlpNNCAxOFY2SDIwVjE4SDRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Money = createIcon('Money', [
  [
    'path',
    {
      d: 'M5 8H7V16H5V8ZM12 8H9C8.45 8 8 8.45 8 9V15C8 15.55 8.45 16 9 16H12C12.55 16 13 15.55 13 15V9C13 8.45 12.55 8 12 8ZM11 14H10V10H11V14ZM18 8H15C14.45 8 14 8.45 14 9V15C14 15.55 14.45 16 15 16H18C18.55 16 19 15.55 19 15V9C19 8.45 18.55 8 18 8ZM17 14H16V10H17V14Z',
      key: '1c1cmd',
    },
  ],
  ['path', { d: 'M2 4V20H22V4H2ZM4 18V6H20V18H4Z', key: '14sbtn' }],
]);

export default Money;
